<mat-card *ngIf="card.display != 'Off' && !userIsStaff" style="min-height: 100px; padding: 0; display: flex; flex-direction: row;">
  <div style="display: flex; flex-direction: column; flex: 1">
    <div class="header-color" style="display: flex; flex-direction: row;">
      <div class="robotoMedium" style="color: white; padding: 10px; font-size: 14pt; display: flex; flex-direction: column; flex: 1;">
          <span translate>Links</span>
      </div>
    </div>
    <div style="display: flex; flex-direction: row; flex: 1; flex-wrap: wrap; justify-content: center">
      <div *ngFor="let link of linkTiles">
        <div [style.background-color]="link.TileColor" (click)="linkTileClick(link)" class="linkBox mat-elevation-z3" style="display: flex; flex-direction: column; cursor: pointer; justify-content: center; align-items: center">
          <img *ngIf="hasImage(link)" style="display: flex; flex-direction: row; width: 65px;max-height: 65px;" src="data:image/jpg;base64,{{link.TileImageFile}}">
          <div style="display: flex; flex-direction: row; justify-content: center; align-items: center; text-align: center; padding: 1px; font-size: 10pt">{{link.PortalName | ellipsis: 24}}</div>
        </div>
      </div>
      <div *ngIf="linkTiles.length <= 0" style="display: flex; flex-direction: column; justify-content: center; flex: 1; align-items: center; padding: 20px;">
          <span translate>No district links available.</span>
      </div>
    </div>
  </div>
</mat-card>
